// extracted by mini-css-extract-plugin
export default {"header":"header_header__WgvvC","header__navigation":"header_header__navigation__R9aUK","link":"header_link__1ifqP","link_active":"header_link_active__9-LE+"};